import type { TutorialStep } from '@/types/tutorials';


export type TutorialActionName = string;

export type TutorialActionHandler = (step: TutorialStep) => void;

export interface TutorialActionsRegistry {

	register: (name: TutorialActionName, handler: TutorialActionHandler) => void;
	unregister: (name: TutorialActionName) => void;

	run: (name?: TutorialActionName, step?: TutorialStep) => void;
}


const handlers: Partial<Record<TutorialActionName, TutorialActionHandler>> = {};

export const tutorialActions: TutorialActionsRegistry = {
	register: (name, handler) => {
		if (!name || typeof handler !== 'function') return;
		handlers[name] = handler;
	},
	unregister: (name) => {
		if (!name) return;
		delete handlers[name];
	},
	run: (name, step) => {
		if (!name) return;
		const fn = handlers[name];
		if (typeof fn === 'function') {
			try {
				fn(step ?? ({} as TutorialStep));
			} catch (error) {
				console.error('[TutorialActions] Error running action', name, error);
			}
		} else {
			console.warn('[TutorialActions] No handler registered for', name);
		}
	},
};

